<template>
    <div class="ui segment" style="padding:0;overflow: hidden;" :class="[color]">
        <div v-if="title"
            class="ui segment no_border"
            style="padding: 0.5em 1em;margin-bottom:0;">
            <h3 style="margin-bottom: 0;"
                :style="is_title_have_link ? {cursor: 'pointer'} : {}"
                @click="title_click()">
                {{ title }}
            </h3>
            <span v-if="date" class="date">
                {{ date }}
            </span>
            <div v-if="sub_title"
                v-html="sub_title"
                style="text-align: right;"
                class="ui top right attached large label">
            </div>
            <div class="clear">
            </div>
        </div>
        <div v-if="keys.length"
            @click="data_card_click()"
            class="ui segments no_border"
            style="margin-top:0;" >
            <div class="ui segment" style="padding: 0.5em 1em;" v-for="key in keys">
                <span v-if="is_show_column">
                    <span v-if="i_18n_key">
                        {{ get_i_18n(key) }}：
                        <slot :name="key">
                            <span v-html="get_column(key)"></span>
                        </slot>
                    </span>
                </span>
                <slot v-else :name="key">
                    <span v-html="get_column(key)"></span>
                </slot>
            </div>
        </div>
        <transition name="slide-fade" mode="out-in">
            <div v-if="!is_show_buttons && !!$slots.buttons"
                @click="data_card_click()"
                style="cursor: pointer;"
                class="ui bottom right attached label">
                <i class="ellipsis horizontal icon" style="margin: 0;"></i>
            </div>
        </transition>

        <transition name="slide-fade" mode="out-in">
            <div v-if="is_show_buttons" style="padding: 6px;text-align: right;">
                <slot name="buttons">
                </slot>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "ToolDataCard",
    components: {
    },
    props: {
        scope: {
            default: 'provider',
            type: String
        },
        title: {
            default: '',
            type: String
        },
        title_link: {
            default: () => { return {} },
            type: Object
        },
        sub_title: {
            default: '',
            type: String
        },
        date: {
            default: '',
            type: String
        },
        object: {
            default: () => { return {} },
            type: Object
        },
        keys: {
            // EX ['內文1', '內文2', '備註', ... ]
            default: () => { return [] },
            type: Array
        },
        keys_data_change: {
            default: () => { return {} },
            type: Object
        },
        /*
         * template 設定
        **/
         color: {
             default: '',
             type: String
         },
         /*
          * Setting
         **/
          is_show_column: {
              default: false,
              type: Boolean
          },
          i_18n_key: {
              default: '',
              type: String
          },
        /*
         * Slot
         *  title, datas, btns
        **/
    },
    data() {
        return {
            is_initialized: false,
            is_show_buttons: false,
        }
    },
    computed: {
        current_store() {
            let scope = this.$store.state.current_scope
            return this.$store.state[scope].tool_data_card_module
        },
        current_identity() {
            return this.current_store.current_identity
        },
        is_title_have_link() {
            return (this.title_link && this.title_link.name) ? true : false
        }
    },
    watch: {
        re_init: {
            deep: true,
            handler(value) {
                this.init()
            }
        },
        current_identity: {
            deep: true,
            handler(value) {
                if (this.object.identity != value) {
                    this.is_show_buttons = false
                }
            }
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        async init () {
            await new Promise(resolve => {
                this.is_initialized = false
            })
            // await this.init_test()
            await new Promise(resolve => {
                this.is_initialized = true
            })
        },
        title_click() {
            if (this.is_title_have_link) {
                this.$router.push(this.title_link)
            }
        },
        get_i_18n(key) {
            let default_key = `models.attributes.${this.i_18n_key}.${key}`
            let is_find = this.$te(default_key)
            if (is_find) {
                return this.$t(default_key)
            } else {
                return this.$t(`ui.pages.${this.i_18n_key}.${key}`)
            }
        },
        get_column(key) {
            try {
                if (this.object[key]) {
                    return this.object[key]
                }
                return '-'
            } catch (result) {
                return result
            }
        },
        data_card_click() {
            this.current_store.current_identity = this.object.identity
             if(!!this.$slots.buttons) {
                 this.is_show_buttons = !this.is_show_buttons
             }
        }
    },
}
</script>
<style lang="scss" scoped>
.no_border {
    border: 0 !important;
    box-shadow: 0 0 0 0 !important;
}
</style>
